import { i18n } from '../../i18n/lang';

export const { t } = i18n.global;
